
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const VerticalMovementPage = lazy(() => import('./VerticalMovementPage'));
const path = 'reports/vertical-movement';
const VerticalMovementRoute: FuseRouteItemType = {
	path: path,
	element: <VerticalMovementPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Vertical Movement',
					helpName: 'Vertical Movement'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default VerticalMovementRoute;
